/**
 * 방문/발렛 enum
 */
export enum RepairMethodStatus {
  VALET = "발렛",
  VISIT = "고객방문",
  ON_SITE = "출장",
}
/**
 * 방문/발렛 key type
 */
export type RepairMethodStatusType = keyof typeof RepairMethodStatus;
